import React from "react";
import {Switch} from "antd";
import classNames from "classnames";
import {StringBuilder} from "../../AppUtils.js";
import "./search-by-created-switch.css";

export const SearchByCreatedSwitch = ({searchByCreated, onChange}) => {
    return (
        <div
            className={classNames("search-by-created-container", {
                active: !searchByCreated
            })}>
            <span className="switch-label">
                {new StringBuilder("סינון לפי תאריך").append(searchByCreated ? "הזמנה" : "אספקה").toString()}
            </span>
            <Switch checked={!searchByCreated} onClick={onChange} />
        </div>
    );
};
